import React, { useState } from 'react';

import { Chat } from '../types';

import ChatListItem from './ChatListItem';

interface ConversationWelcomeProps {
  chats: Chat[];
  onChatSelect: (chatId: string) => void;
}

const ConversationWelcome: React.FC<ConversationWelcomeProps> = ({
  chats,
  onChatSelect,
}) => {
  const [showStarredOnly, setShowStarredOnly] = useState(false);

  const filteredChats = showStarredOnly
    ? chats.filter(chat => chat.starred)
    : chats;

  return (
    <div className='flex-1 p-6 overflow-y-auto'>
      <div className='max-w-4xl mx-auto'>
        {chats.length > 0 ? (
          <div>
            <div className='flex items-center justify-between mb-4'>
              <h2 className='text-lg font-semibold text-gray-800'>
                Your Past Conversations
              </h2>
              <label className='flex items-center gap-2 cursor-pointer text-sm text-gray-600 hover:text-gray-800'>
                <input
                  type='checkbox'
                  checked={showStarredOnly}
                  onChange={(e) => setShowStarredOnly(e.target.checked)}
                  className='w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
                />
                <span>Starred only</span>
              </label>
            </div>
            <div className='grid gap-2'>
              {filteredChats.map(chat => (
                <ChatListItem
                  key={chat.id}
                  chat={chat}
                  onSelect={onChatSelect}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className='text-center text-gray-500'>
            <div className='text-lg font-medium mb-2'>No conversations yet</div>
            <div className='text-sm'>Create your first chat to get started</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConversationWelcome;
